export function addEventListener(type, listener) {
  document.addEventListener(type, listener);
}

export function removeEventListener(type, listener) {
  document.removeEventListener(type, listener);
}

export function dispatchEvent(ev) {
  console.log(`🎯 Custom event dispatched: ${ev.type} (${ev.detail})`);
  document.dispatchEvent(ev);
}

export function formSubmitEvent(params) {
  return new CustomEvent('on-form-submit', {
    detail: params,
    bubbles: true,
    composed: true,
    cancelable: true,
  });
}

export function formFailureEvent(params) {
  return new CustomEvent('on-form-failure', {
    detail: params,
    bubbles: true,
    composed: true,
    cancelable: true,
  });
}
